import { useParams, Link } from 'react-router-dom';

import { Icon } from '../../icon';
import { Button } from '../../shadcn/button';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { useStore } from '@/store';

export const FullDocLink = ({ docId }: { docId: string }) => {
  const { matterId, subsetId } = useParams();
  const { data: matter } = useGetMatterV2(matterId);
  const { closeReferenceDrawer } = useStore();
  const documentSubsetId = subsetId ?? matter?.allDocumentsCaseId;

  if (!matterId || !documentSubsetId) return null;

  return (
    <Tooltip>
      <TooltipTrigger
        asChild
        onClick={() => {
          closeReferenceDrawer();
        }}
      >
        <Button asChild variant="blue" size="iconSm">
          <Link to={`/matters/${matterId}/subsets/${documentSubsetId}/docs/${docId}`}>
            <Icon className="lucide--file-input" />
          </Link>
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>View in documents page</p>
      </TooltipContent>
    </Tooltip>
  );
};
